import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { IBonusSettings } from 'src/app/models/settings/bonusSettings.interface';
import { IFreeBetSetting } from 'src/app/models/settings/freeBetSetting.interface';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { OddsValidationMode, PageType, TimeFilter } from 'src/app/models/enums';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { IMultiwayRestriction } from 'src/app/models/settings/multiwayRestriction.interface';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { IOutcomeCodeValue } from 'src/app/models/betType/outcomeCodeValue.interface';
import { IUserTM } from 'src/app/ticket-manager/models/user/userTM.interface';
import { IEventSrc } from 'src/app/models/event/eventSrc.interface';
import { ITicketDialogModel } from 'src/app/models/ticket-validation/ticketDialogModel.interface';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';

@Injectable()

export class StorageService {
  private localeId: string;
  private ticketItemGroupsInTicket: { [eventId: number]: ITicketItemGroup };

  constructor(@Inject(LOCALE_ID) locale: string) {
    // console.log('StorageService locale' + locale);
    this.localeId = locale.toString();
    if (this.language !== this.localeId) {
      // console.log('StorageService if (this.language !== this.localeId) locale' + locale);
      this.language = this.localeId;
      this.betTypeShowTypes = null;
      localStorage.setItem('languageChanged', 'true');
      sessionStorage.removeItem('betTypeShowTypes');
      // console.log('Language CHanged');
    } else {
      // console.log('StorageService ELSE (this.language !== this.localeId) locale' + locale);
      localStorage.setItem('languageChanged', 'false');
      // console.log('Language not changed');
    }

    const ticketItemGroupsFromStorage = sessionStorage.getItem('ticketItemGroups');
    this.ticketItemGroupsInTicket =  ticketItemGroupsFromStorage ? JSON.parse(ticketItemGroupsFromStorage) : {};
  }

  public clearSessionStorage() {
    sessionStorage.clear();
  }

  public clearLocalStorage() {
    localStorage.clear();
  }

  get freeBetBalance(): number {
    return +sessionStorage.getItem('FBBalance');
  }

  set freeBetBalance(balance: number) {
    if (balance == null) {
      sessionStorage.removeItem('FBBalance');
    } else {
      sessionStorage.setItem('FBBalance', balance.toString());
    }
  }

  get accountBalance(): number {
    return +sessionStorage.getItem('ABalance');
  }

  set accountBalance(balance: number) {
    if (balance == null) {
      sessionStorage.removeItem('ABalance');
    } else {
      sessionStorage.setItem('ABalance', balance.toString());
    }
  }

  get language(): string {
    // console.log('StorageService get language');
    let language = localStorage.getItem('languageId');
    if (!language) {
      // console.log('StorageService get from localeId' + this.localeId + '');
      language = this.localeId;
      this.language = language;

    }
    return language;
  }

  set language(languageId: string) {
    if (languageId == null) {
      localStorage.removeItem('languageId');
    } else {
      localStorage.setItem('languageId', languageId);
    }
  }

  get bonus(): IBonusSettings[] {
    const bonussSettings = sessionStorage.getItem('bonus');
    let parsedBonussSettings: IBonusSettings[] = [];
    if (bonussSettings) {
      parsedBonussSettings = JSON.parse(bonussSettings);
      for (const bonussSetting of parsedBonussSettings) {
        bonussSetting.fromDate = new Date(bonussSetting.fromDate.toString());
        bonussSetting.toDate = bonussSetting.toDate? new Date(bonussSetting.toDate.toString()): null;
      }
    }
    return parsedBonussSettings;
  }

  set bonus(bonus: IBonusSettings[]) {
    if (bonus == null) {
      sessionStorage.removeItem('bonus');
    } else {
      sessionStorage.setItem('bonus', JSON.stringify(bonus));
    }
  }

  getPlayerBonus(playerId: number): IBonusSettings[] {
    const playerBonussSettings = sessionStorage.getItem('playerBonus' + playerId);
    let parsedPlayerBonussSettings: IBonusSettings[] = [];
    if (playerBonussSettings) {
      parsedPlayerBonussSettings = JSON.parse(playerBonussSettings);
      for (const bonussSetting of parsedPlayerBonussSettings) {
        bonussSetting.fromDate = new Date(bonussSetting.fromDate.toString());
        bonussSetting.toDate = bonussSetting.toDate? new Date(bonussSetting.toDate.toString()): null;
      }
    }
    return parsedPlayerBonussSettings;
  }

  setPlayerBonus(playerBonus: IBonusSettings[], playerId: number) {
    sessionStorage.setItem('playerBonus' + playerId, JSON.stringify(playerBonus));
  }

  getFreebetSettings(playerId: number): IFreeBetSetting {
    const playerFBS = sessionStorage.getItem('freeBetSettings' + playerId);
    let parsedplayerFBS: IFreeBetSetting = null;
    if (playerFBS) {
      parsedplayerFBS = JSON.parse(playerFBS);
      parsedplayerFBS.fromDate = new Date(parsedplayerFBS.fromDate.toString());
      parsedplayerFBS.toDate = new Date(parsedplayerFBS.toDate.toString());

    }
    return parsedplayerFBS;
    // return playerFBS ? JSON.parse(playerFBS) : null;
  }

  setFreebetSettings(freebetSettings: IFreeBetSetting, playerId: number) {
    sessionStorage.setItem('freeBetSettings' + playerId, JSON.stringify(freebetSettings));
  }

  get betTypeShowTypes(): { [betTypeId: number]: IBetTypeShowType } {
    const btst = sessionStorage.getItem('betTypeShowTypes');
    // console.log('Storage get BetTypeShowTypes, has value: ',  btst ? 'true'  : 'false');
    return btst ? JSON.parse(btst) : null;
  }

  set betTypeShowTypes(betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }) {
    // console.log('Storage Set BetTypeShowTypes :', betTypeShowTypes);
    if (betTypeShowTypes == null) {
      sessionStorage.removeItem('betTypeShowTypes');
    } else {
      sessionStorage.setItem('betTypeShowTypes', JSON.stringify(betTypeShowTypes));
    }
  }

  get srcSelectionIdsLive(): ISrcSelectionIds {
    const srcSelectionIds = sessionStorage.getItem('srcSelectionIdsLive');
    return srcSelectionIds ? JSON.parse(srcSelectionIds) : { sId: null, rId: null, cId: null, isLive: true };
  }

  set srcSelectionIdsLive(srcSelectionIds: ISrcSelectionIds) {
    if (srcSelectionIds == null) {
      sessionStorage.removeItem('srcSelectionIdsLive');
    } else {
      sessionStorage.setItem('srcSelectionIdsLive', JSON.stringify(srcSelectionIds));
    }
  }

  get srcSelectionIdsPrematch(): ISrcSelectionIds {
    const srcSelectionIds = sessionStorage.getItem('srcSelectionIdsPM');
    return srcSelectionIds ? JSON.parse(srcSelectionIds) : { sId: null, rId: null, cId: null, isLive: false };
  }

  set srcSelectionIdsPrematch(srcSelectionIds: ISrcSelectionIds) {
    if (srcSelectionIds == null) {
      sessionStorage.removeItem('srcSelectionIdsPM');
    } else {
      sessionStorage.setItem('srcSelectionIdsPM', JSON.stringify(srcSelectionIds));
    }
  }


  get timeFilterValue(): TimeFilter {
    const timeFilterValue = sessionStorage.getItem('timeFilterValue');
    return timeFilterValue ? JSON.parse(timeFilterValue) : TimeFilter.All;
  }

  set timeFilterValue(value: TimeFilter) {
    if (value == null) {
      sessionStorage.removeItem('timeFilterValue');
    } else {
      sessionStorage.setItem('timeFilterValue', JSON.stringify(value));
    }
  }

  get pageType(): PageType {
    const pageType = sessionStorage.getItem('pageType');
    return pageType ? JSON.parse(pageType) : PageType.Prematch;
  }

  set pageType(value: PageType) {
    if (value == null) {
      sessionStorage.removeItem('pageType');
    } else {
      sessionStorage.setItem('pageType', JSON.stringify(value));
    }
  }

  get ticketItemGroups(): { [eventId: number]: ITicketItemGroup } {
    const ticketItemGroupsFromStorage = sessionStorage.getItem('ticketItemGroups');
    return ticketItemGroupsFromStorage ? JSON.parse(ticketItemGroupsFromStorage) : {};
  }

  set ticketItemGroups(ticketItemGroupsInTicket: { [eventId: number]: ITicketItemGroup }) {
    if (ticketItemGroupsInTicket == null) {
      this.ticketItemGroupsInTicket = {};
      sessionStorage.removeItem('ticketItemGroups');
    } else {
      this.ticketItemGroupsInTicket = ticketItemGroupsInTicket;
      sessionStorage.setItem('ticketItemGroups', JSON.stringify(ticketItemGroupsInTicket));
    }
  }

  isOutcomeInTicket(eventId: number, betOutcomeId: number): boolean {
    if (this.ticketItemGroupsInTicket[eventId]?.ticketItems[betOutcomeId]) {
      return true;
    }
    return false;
  }

  get multiwayRestrictions(): { [betTypeOutcomeId: number]: IMultiwayRestriction } {
    return JSON.parse(localStorage.getItem('restrictions'));
  }

  set multiwayRestrictions(res: { [betTypeOutcomeId: number]: IMultiwayRestriction }) {
    if (res == null) {
      localStorage.removeItem('restrictions');
    } else {
      localStorage.setItem('restrictions', JSON.stringify(res));
    }
  }

  get productVersion(): any {
    const vers = localStorage.getItem('productVersion');
    return vers ? JSON.parse(vers) : '0';
  }

  set productVersion(version: any) {
    if (version == null) {
      localStorage.removeItem('productVersion');
    } else {
      localStorage.setItem('productVersion', JSON.stringify(version));
    }
  }

  get authToken(): string {
    return localStorage.getItem('AuthToken') ? localStorage.getItem('AuthToken') : null;
  }

  set authToken(token: string) {
    if (token == null) {
      // console.log('StorageService Remove token');
      localStorage.removeItem('AuthToken');

    } else {
      // console.log('StorageService set token');
      localStorage.setItem('AuthToken', token);
    }
  }

  get userName(): string {
    return localStorage.getItem('userName') ? localStorage.getItem('userName') : null;
  }

  set userName(userName: string) {
    if (userName == null) {
      // console.log('StorageService Remove uname');
      localStorage.removeItem('userName');
    } else {
      // console.log('StorageService set uname');
      localStorage.setItem('userName', userName);
    }
  }

  // get languageChanged(): boolean {
  //   return localStorage.getItem('languageChanged') !== 'false';
  // }

  get favoriteCompetitions(): ICompetition[]{
    const favs = localStorage.getItem('favoriteCompetitions');
    return favs ? JSON.parse(favs) : [];
  }

  set favoriteCompetitions(sports: ICompetition[]){
    if (sports == null) {
      localStorage.removeItem('favoriteCompetitions');
    } else {
      localStorage.setItem('favoriteCompetitions', JSON.stringify(sports));
    }
  }

  get favoriteLiveEvents(): number[]{
    const favs = localStorage.getItem('favouriteLiveEvents');
    return favs ? JSON.parse(favs) : [];
  }

  set favoriteLiveEvents(events: number[]){
    if (events == null) {
      localStorage.removeItem('favouriteLiveEvents');
    } else {
      localStorage.setItem('favouriteLiveEvents', JSON.stringify(events));
    }
  }

  get favoriteLiveEventsSRC(): IEventSrc[]{
    const favs = sessionStorage.getItem('favouriteLiveEventsSRC');
    return favs ? JSON.parse(favs) : [];
  }

  set favoriteLiveEventsSRC(events: IEventSrc[]){
    if (events == null) {
      sessionStorage.removeItem('favouriteLiveEventsSRC');
    } else {
      sessionStorage.setItem('favouriteLiveEventsSRC', JSON.stringify(events));
    }
  }


  get oddsValidationMode(): OddsValidationMode {
    const valMode = localStorage.getItem('oddsValidationMode');
    return valMode ? +valMode : OddsValidationMode.AcceptAllOdds;
  }

  set oddsValidationMode(oddsValidation: OddsValidationMode){
    if (oddsValidation == null) {
      localStorage.removeItem('oddsValidationMode');
    } else {
      localStorage.setItem('oddsValidationMode', oddsValidation.toString());
    }
  }

  // get eventsForNotifications(): number[]{
  //   const eventsForNotification = localStorage.getItem('eventIdsForNotifications');
  //   return eventsForNotification ? JSON.parse(eventsForNotification) : [];
  // }

  // set eventsForNotifications(eventIdsForNotifications: number[]){
  //   if (eventIdsForNotifications == null) {
  //     localStorage.removeItem('eventIdsForNotifications');
  //   } else {
  //     localStorage.setItem('eventIdsForNotifications', JSON.stringify(eventIdsForNotifications));
  //   }
  // }

  get outcomeCodeValues(): IOutcomeCodeValue[] {
    const btst = sessionStorage.getItem('outcomeCodeValues');
    return btst ? JSON.parse(btst) : null;
  }

  set outcomeCodeValues(outcomeCodeValues: IOutcomeCodeValue[]) {
    if (outcomeCodeValues == null) {
      sessionStorage.removeItem('outcomeCodeValues');
    } else {
      sessionStorage.setItem('outcomeCodeValues', JSON.stringify(outcomeCodeValues));
    }
  }

 // REMOVE
  get userTM(): IUserTM{
    const tmu = localStorage.getItem('tmUser');
    return tmu ? JSON.parse(tmu) : null;
  }

// REMOVE
  set userTM(userTM: IUserTM){
    if (userTM == null) {
      localStorage.removeItem('tmUser');
    } else {
      localStorage.setItem('tmUser', JSON.stringify(userTM));
    }
  }

  get ticketValidationId(): number {
    return +localStorage.getItem('tValidationN');
  }

  set ticketValidationId(ticketValidationId: number) {
    if (ticketValidationId == null) {
      localStorage.removeItem('tValidationN');
    } else {
      localStorage.setItem('tValidationN', ticketValidationId.toString());
    }
  }

  get dialogModel(): ITicketDialogModel {
    const dialogModel = localStorage.getItem('dialogModel');
    return  dialogModel ? JSON.parse(dialogModel) : null;
  }

  set dialogModel(dialogModel: ITicketDialogModel) {
    if (dialogModel == null) {
      localStorage.removeItem('dialogModel');
    } else {
      localStorage.setItem('dialogModel',  JSON.stringify(dialogModel));
    }
  }

  get affiliate() {
    const tmu = localStorage.getItem('affiliate');
    let aff: IAffiliate = null;
    if (tmu) {
      aff = JSON.parse(tmu);
      aff.dateCreated = new Date(aff.dateCreated);
      aff.dateUpdated = new Date(aff.dateUpdated);
      aff.birthDate = new Date(aff.birthDate);
    }
    return aff;
  }

  set affiliate(affiliate: IAffiliate){
    if (affiliate == null) {
      localStorage.removeItem('affiliate');
    } else {
      localStorage.setItem('affiliate', JSON.stringify(affiliate));
    }
  }

  get affiliateJwtToken(): string{
    const tmu = localStorage.getItem('affiliateJwtToken');
    return tmu ? JSON.parse(tmu) : null;
  }

  set affiliateJwtToken(affiliateJwtToken: string){
    if (affiliateJwtToken == null) {
      localStorage.removeItem('affiliateJwtToken');
    } else {
      localStorage.setItem('affiliateJwtToken', JSON.stringify(affiliateJwtToken));
    }
  }

  get affiliateRefreshToken(): string{
    const tmu = localStorage.getItem('affiliateRefreshToken');
    return tmu ? JSON.parse(tmu) : null;
  }

  set affiliateRefreshToken(affiliateRefreshToken: string){
    if (affiliateRefreshToken == null) {
      localStorage.removeItem('affiliateRefreshToken');
    } else {
      localStorage.setItem('affiliateRefreshToken', JSON.stringify(affiliateRefreshToken));
    }
  }


}
